import { message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Login from "../commons/Login";
import Header from "./components/Header";
import { resetToast, showPopup } from "../redux/action/common";
import ShareEventPopup from "./components/ShareEventPopup";
import { getUserCategoryData } from "../redux/action/user/category";
import SachLoader from "../commons/Loader";
import isEmpty from "lodash/isEmpty";
import { Modal as Modal2 } from "react-bootstrap";
import "./style.css";
import { logoutSessionForPasswordChange } from "../utils/util";
import { useNavigate } from "react-router-dom";
import { UserRoutes } from "../routes";
import { getCookiesLangDataAPI, getMetaTagDataAPI, getvideoDetailsAPI, getWeeklySubsCriptionAPI } from "../redux/action/common-action";
import DocumentMeta from "react-document-meta";
import ThoughtPlayer from "./components/Dashboard/ThoughtPlayer";
import HeaderNew from "./components/HeaderNew";
import FooterNew from "./components/FooterNew";
import "./animation.css";
import { SHARED_BASE_URL } from "../redux/constants";

const BaseDashboard = (props) => {
  const { toastType, toastData, resetToast, commonData, showPopup, getUserCategoryData, isLoading, categoryData, getWeeklySubsCriptionAPI, weeklyThoughtData, getCookiesLangDataAPI, cookiesLangData, getMetaTagDataAPI, metaTagData, getvideoDetailsAPI, videoDetailsData } = props;

  const [show, setShow] = useState(false);
  const [videoData, setVideoData] = useState(false);
  const [thoughtData, setThoughtData] = useState(true);
  const [playerModal, setPlayerModal] = useState(false);
  const [videoUrlData, setVideoUrlData] = useState();
  const thought = weeklyThoughtData && weeklyThoughtData.length > 0 && weeklyThoughtData.filter((thought) => thought.createType === "Thought");
  const video = weeklyThoughtData && weeklyThoughtData.length > 0 && weeklyThoughtData.filter((thought) => thought.createType === "video");

  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location.pathname 1", location);
  useEffect(() => {
    if (toastType) {
      showToast();
      resetToast();
    }
  }, [toastType]);

  useEffect(() => {
    if (isEmpty(categoryData)) {
      getUserCategoryData();
    }
    getCookiesLangDataAPI();
    getWeeklySubsCriptionAPI();
    getMetaTagDataAPI();
  }, []);

  useEffect(() => {
    if (weeklyThoughtData && video.length > 0) {
      console.log(video[0].videoUrl);
      getvideoDetailsAPI(video[0].videoUrl);
    }
  }, [weeklyThoughtData]);
  const renderLoginPopup = () => {
    return (
      <Modal className="w-100" centered visible={true} onCancel={() => showPopup(null)} footer={null}>
        <Login {...props} />
      </Modal>
    );
  };

  const THoDToggle = () => {
    document.querySelector(".thoughtOftheDay").classList.toggle("show");
    document.querySelector(".THoD-btn").classList.toggle("show");
  };

  const renderShareEventPopup = () => {
    return <ShareEventPopup popupData={commonData?.popupData} />;
  };

  const showToast = () => {
    switch (toastType) {
      case "success":
        message.success(toastData.message);
        break;
      case "error":
        message.error(toastData.message);
        break;
      case "warning":
        message.warning(toastData.message);
        break;
      case "password":
        message.success("Password Changed Successfully!");
        setShow(true);
        break;
      default:
        break;
    }
  };

  // console.log("cookieFlag = " + window.localStorage.cookieFlag);

  const modalSection = cookiesLangData && cookiesLangData.modalSection;
  const metaData = metaTagData && metaTagData.length > 0 && metaTagData.filter((item) => window.location.pathname === item.pageName);

  const meta = metaData &&
    metaData[0] && {
      title: metaData[0].metaTitle,
      description: metaData[0].metaDescription,
      canonical: SHARED_BASE_URL + "/" + metaData[0]?.canonicalTag?.toLowerCase(),
      meta: {
        name: {
          keywords: metaData[0].metaKEyword,
          robots: SHARED_BASE_URL === "https://sach.org.in" ? "max-image-preview:large, index, follow" : "max-image-preview:large, noindex, nofollow",
          "twitter:title": metaData[0].metaTitle,
          "twitter:description": metaData[0].metaDescription,
          "twitter:url": SHARED_BASE_URL + "/" + metaData[0]?.canonicalTag?.toLowerCase(),
        },
        property: {
          "og:site_name": metaData[0].metaTitle,
          "og:url": SHARED_BASE_URL + "/" + metaData[0]?.canonicalTag?.toLowerCase(),
          "og:title": metaData[0].metaTitle,
          "og:description": metaData[0].metaDescription,
        },
      },
    };

  if (isLoading || isEmpty(categoryData)) {
    return <SachLoader />;
  }

  const handleVideoData = () => {
    if (video.length > 0) {
      setVideoData(true);
      setThoughtData(false);
    }
  };

  const handlePlayVideo = (data) => {
    setPlayerModal(true);
    setVideoUrlData(data);
  };

  const videoAllDetails = videoDetailsData.channel && videoDetailsData.channel.sections && videoDetailsData.channel.sections[0] && videoDetailsData.channel.sections[0].videos && videoDetailsData.channel.sections[0].videos[0];

  return (
    <>
      <DocumentMeta {...meta} />
      <HeaderNew categoryData={categoryData} getUserCategoryData={getUserCategoryData} />
      <main className={location.pathname === UserRoutes.USER_ROOT || location.pathname === UserRoutes.ABOUT ? "main-content newhome" : location.pathname === UserRoutes.USER_BLOGS || location.pathname === UserRoutes.USER_EVENT_DETAILS ? "main-content newhome" : "main-content newhome InnerPage"}>
        <Outlet />
        {commonData?.popupType !== "" && commonData?.popupType === "shareEvent" && renderShareEventPopup()}
        {commonData?.popupType !== "" && (commonData?.popupType === "login" || commonData?.popupType === "signUp") && renderLoginPopup()}
      </main>
      <FooterNew />

      <Modal2 show={show} centered className="sach-modal" backdrop="static" keyboard={false}>
        <div className="px-md-5 text-center mt-5">
          <img src={require("../static/user/img/icons/success-tick.svg").default} alt="Successfully" />
          <div className="modal-heading text-center my-4">
            <h1>
              <div>Password</div>
              <div>Successfully Changed!</div>
            </h1>
            <span>Please login again using your updated credentials</span>
          </div>

          <div className="my-3 text-center">
            <button className="btn-sach bg-sach-dark justify-content-center w-100" onClick={() => logoutSessionForPasswordChange(navigate)}>
              <span className="py-1">Login Now</span>
            </button>
          </div>
        </div>
      </Modal2>

      {/* {window.localStorage.cookieFlag !== "true" || window.localStorage.cookieFlag === undefined || window.localStorage.cookieFlag == null ? (
        <div className="cookiesPolicy">
          <img src={require("../static/user/img/icons/cookies.svg").default} alt="cookie" />
          <div className="cookieContent">
            <span>{modalSection && modalSection.title}</span>
            <div>
              <Link to={UserRoutes.COOKIE_POLICY}>{modalSection && modalSection.cookPolicyText}</Link>
              <Link to={UserRoutes.USER_ROOT}
                className="ms-4"
                onClick={(e) => {
                  e.preventDefault(0);
                  window.localStorage.cookieFlag = true;
                  document.querySelector(".cookiesPolicy").style.display = "none";
                }}
              >
                {modalSection && modalSection.declineText}
              </Link>
            </div>
          </div>
          <div>
            <button
              className="btn btn-sach bg-sach"
              onClick={() => {
                window.localStorage.cookieFlag = true;
                document.querySelector(".cookiesPolicy").style.display = "none";
              }}
            >
              <span>{modalSection && modalSection.acceptText}</span>
            </button>
          </div>
        </div>
      ) : (
        ""
      )} */}

      {weeklyThoughtData && weeklyThoughtData.length > 0 && (
        <button className="btn btn-sach bg-sach THoD-btn show" onClick={() => THoDToggle()}>
          <span>{weeklyThoughtData && weeklyThoughtData.length > 0 && weeklyThoughtData[0].messageData.btnText} &nbsp; 🔥</span>
        </button>
      )}

      <div className="thoughtOftheDay">
        <span
          className="THoD-close"
          onClick={() => {
            THoDToggle();
            setThoughtData(true);
            setVideoData(false);
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.4142 11.9998L17.7072 7.70676C18.0982 7.31576 18.0982 6.68376 17.7072 6.29276C17.3162 5.90176 16.6842 5.90176 16.2933 6.29276L12.0002 10.5858L7.70725 6.29276C7.31625 5.90176 6.68425 5.90176 6.29325 6.29276C5.90225 6.68376 5.90225 7.31576 6.29325 7.70676L10.5862 11.9998L6.29325 16.2928C5.90225 16.6838 5.90225 17.3158 6.29325 17.7068C6.48825 17.9018 6.74425 17.9998 7.00025 17.9998C7.25625 17.9998 7.51225 17.9018 7.70725 17.7068L12.0002 13.4138L16.2933 17.7068C16.4882 17.9018 16.7443 17.9998 17.0002 17.9998C17.2562 17.9998 17.5122 17.9018 17.7072 17.7068C18.0982 17.3158 18.0982 16.6838 17.7072 16.2928L13.4142 11.9998Z" />
          </svg>
        </span>
        <div className="THoD-head">
          <img src={require("../static/user/img/icons/thoughtOftheDay-Icon.svg").default} alt="thoughtOftheDay" />
          <span>{weeklyThoughtData && weeklyThoughtData.length > 0 && weeklyThoughtData[0].messageData.btnText}</span>
        </div>
        <div className="THoD-body">
          {weeklyThoughtData &&
            thought.length > 0 &&
            (thoughtData ? (
              <>
                <svg width="23" height="21" viewBox="0 0 23 21" className="quoteIcon" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.7692 0.207083L22.1946 4.5805C21.0454 4.4782 20.1116 4.6828 19.3934 5.19431C18.6751 5.68025 18.1723 6.39637 17.885 7.34266C17.6216 8.26338 17.5737 9.33755 17.7413 10.5652H22.7692V21H13.0007V10.5652C13.0007 6.8823 13.8028 4.09457 15.4069 2.20198C17.0111 0.283811 19.4652 -0.381154 22.7692 0.207083ZM9.7685 0.207083L9.19388 4.5805C8.04465 4.4782 7.1109 4.6828 6.39262 5.19431C5.67435 5.68025 5.17156 6.39637 4.88425 7.34266C4.62088 8.26338 4.573 9.33755 4.7406 10.5652H9.7685V21H0V10.5652C0 6.8823 0.802071 4.09457 2.40621 2.20198C4.01035 0.283811 6.46445 -0.381154 9.7685 0.207083Z" />
                </svg>
                <a onClick={() => handleVideoData()}>
                  <h2>{thought[0].writeThoughtTitle.substring(0, 120)}</h2>
                </a>
              </>
            ) : null)}

          {weeklyThoughtData && video.length > 0 && videoData && (
            <>
              <h3>{video[0].writeVideoTitle}</h3>
              <span className="VidDurtn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M11.5 14.5996V9.4006L14.309 11.9996L11.5 14.5996ZM12.339 7.4526C11.841 6.9906 11.114 6.8706 10.488 7.1456C9.878 7.4116 9.5 7.9806 9.5 8.6296V15.3706C9.5 16.0196 9.878 16.5886 10.488 16.8546C10.711 16.9526 10.948 16.9996 11.181 16.9996C11.604 16.9996 12.019 16.8446 12.338 16.5486L15.98 13.1786C16.311 12.8726 16.5 12.4436 16.5 11.9996C16.5 11.5566 16.311 11.1266 15.98 10.8216L12.339 7.4526ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z" fill="#4D4354" />
                </svg>
                <i> {videoAllDetails && videoAllDetails.duration.substring(0, videoAllDetails.duration.length - 5)}</i>
              </span>
              <div className="ThoD-video" onClick={(e) => handlePlayVideo(video[0])}>
                <img src={videoAllDetails && videoAllDetails.image && videoAllDetails.image.smUrl} alt="video" className="img-fluid" />
              </div>
            </>
          )}
        </div>
        <div className="THoD-footer">
          <div className="thod-aa">
            <b>{weeklyThoughtData && weeklyThoughtData.length > 0 && weeklyThoughtData[0].messageData.chandraSir}</b>
            {/* <span className="thod-like">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Icons-Others=Heart-Outline">
                  <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M7.21968 6C6.35568 6 5.54568 6.334 4.93968 6.941C3.68168 8.201 3.68168 10.252 4.94068 11.514L11.9997 18.585L19.0597 11.514C20.3187 10.252 20.3187 8.201 19.0597 6.941C17.8477 5.726 15.7117 5.728 14.4997 6.941L12.7077 8.736C12.3317 9.113 11.6677 9.113 11.2917 8.736L9.49968 6.94C8.89368 6.334 8.08468 6 7.21968 6ZM11.9997 21C11.7347 21 11.4797 20.895 11.2927 20.706L3.52468 12.926C1.48868 10.886 1.48868 7.567 3.52468 5.527C4.50868 4.543 5.82068 4 7.21968 4C8.61868 4 9.93168 4.543 10.9147 5.527L11.9997 6.614L13.0847 5.528C14.0687 4.543 15.3807 4 16.7807 4C18.1787 4 19.4917 4.543 20.4747 5.527C22.5117 7.567 22.5117 10.886 20.4757 12.926L12.7077 20.707C12.5197 20.895 12.2657 21 11.9997 21Z" fill="#4D4354" />
                </g>
              </svg> */}
            {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.00003 14.0013C7.8227 14.0013 7.65336 13.9313 7.52803 13.8053L2.35003 8.61863C0.992698 7.25864 0.992698 5.04597 2.35003 3.68597C3.00536 3.02997 3.8807 2.66797 4.81336 2.66797C5.74603 2.66797 6.62136 3.02997 7.2767 3.68597L8.00003 4.41064L8.7227 3.68664C9.3787 3.02997 10.254 2.66797 11.1867 2.66797C12.1194 2.66797 12.9947 3.02997 13.65 3.68597C15.0074 5.04597 15.0074 7.25864 13.6507 8.61863L8.47203 13.806C8.3467 13.9313 8.17736 14.0013 8.00003 14.0013Z" fill="#EF5A46" />
              </svg> */}
            {/* </span> */}
          </div>
          {/* <Link className="btn btn-sach bg-sach" to={UserRoutes.USER_THOUGHT_OFTHE_DAY}>
            <span>Explore</span>
          </Link> */}
        </div>
      </div>
      {playerModal && <ThoughtPlayer handleCancel={() => setPlayerModal(false)} videoUrlData={videoUrlData} />}
    </>
  );
};

const mapStateToProps = (state) => {
  const { UserHomePageReducer, CommonReducer } = state;
  const { isLoading, categoryData } = UserHomePageReducer;
  return {
    ...state,
    isLoading,
    categoryData,
    commonData: state?.CommonReducer,
    toastData: CommonReducer.toastData,
    toastType: CommonReducer.toastType,
    passwordType: CommonReducer.passwordType,
    cookiesLangData: CommonReducer.cookiesLangData,
    metaTagData: CommonReducer.metaTagData,
    weeklyThoughtData: CommonReducer.weeklyThoughtData,
    videoDetailsData: CommonReducer.videoDetailsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showPopup: (type, data) => dispatch(showPopup(type, data)),
    getUserCategoryData: (data) => dispatch(getUserCategoryData(data)),
    resetToast: () => dispatch(resetToast()),
    getCookiesLangDataAPI: () => dispatch(getCookiesLangDataAPI()),
    getMetaTagDataAPI: () => dispatch(getMetaTagDataAPI()),
    getWeeklySubsCriptionAPI: () => dispatch(getWeeklySubsCriptionAPI()),
    getvideoDetailsAPI: (data) => dispatch(getvideoDetailsAPI(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BaseDashboard);
